import { newsPage } from "./article_newspage_template";

export const article_newspage = (article) => {

    return newsPage({
        pageType:       article.pageTypeId,
        title:          article.title,
        parsedIntro:    article.parsedIntro,
        mainImage:      article.mainImage,
        content:        article.content,
        published:      article.firstCreated,
        modified:       article.modified,
        created:        article.created,
        hasRightColumn: article.hasRightColumn,
        RightColumn:    article.RightColumn
    });

}